import { render } from "./Refresh.vue?vue&type=template&id=168876a9"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "168876a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('168876a9', script)) {
    api.reload('168876a9', script)
  }
  
  module.hot.accept("./Refresh.vue?vue&type=template&id=168876a9", () => {
    api.rerender('168876a9', render)
  })

}

script.__file = "src/icons/components/filled/Refresh.vue"

export default script